import { render, staticRenderFns } from "./edit-tizhi.vue?vue&type=template&id=43e3c502&scoped=true"
import script from "./edit-tizhi.vue?vue&type=script&lang=ts"
export * from "./edit-tizhi.vue?vue&type=script&lang=ts"
import style0 from "./edit-tizhi.vue?vue&type=style&index=0&id=43e3c502&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e3c502",
  null
  
)

export default component.exports